export class Street {
    constructor(
            public id: number = null,
            public territory_id: number = null,
            public territory: string = null,
            public name: string = null,
            public socr: string = null,
            public post: string = null,
            public nda: string = null,
            public aoguid: string = null) { }
}



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_classes/list/street.ts